import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { submitFilterDTO } from 'src/components/Common/UI/DndTable/types';


const convertToDataTable = (data: IGetCity[]): IGetCity[] => {
  const dataTableData: IGetCity[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllCities = async ( {data} : {data: submitFilterDTO | {}}): Promise<IGetCity[]> => {
  const response =  await axiosDefaultApi.post(`/api/Entities/GetData/Cities`,data);
  return convertToDataTable(response as unknown as IGetCity[]);
};

type QueryFnType = typeof getAllCities;

type UseGetAllCitiesOptions = {
  data: submitFilterDTO | {};
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllCities = ({ data, config }: UseGetAllCitiesOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllCities'],
    queryFn: () => getAllCities({data}),
    onError: (error) =>{
      queryClient.invalidateQueries(["getAllCities"])
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};